import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { filterSelectStyles as styles } from './styles.js';
import { Select, MenuItem, InputLabel, FormControl, withStyles } from '@material-ui/core';

function FilterSelect({ classes, label, values, onChange }) {
    const [selectedValue, setSelectedValue] = useState('');
    const handleChangeSelected = event => {
        onChange(event);
        setSelectedValue(event.target.value);
    };

    return (
        <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="filter-select-label">{label}</InputLabel>
            <Select
                labelId="filter-select-label"
                id="filter-select"
                value={selectedValue}
                onChange={handleChangeSelected}
                label={label}
            >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                {values.map((element, index) => {
                    return (
                        <MenuItem key={`menu-item-${index}`} value={element}>
                            {element.name}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
}

FilterSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    onChange: PropTypes.func
};

export default withStyles(styles)(FilterSelect);
